import moment from '@transfeeradev/moment';

export default value => {
  if (value) {
    return moment(String(value)).format('MM/YYYY');
  }
  return value;
};
